<template>
  <fieldset class="p-fieldset" :class="{ 'location-address-fieldset--invalid': invalid }">
    <legend class="p-fieldset-legend p-p-2">
      {{ $t(label) }}<span class="warning-color">*</span>
    </legend>

    <div v-if="addressIsNotEmpty" class="p-m-2">
      <div>{{ formattedAddress }}</div>

      <Button style="width: auto"
              :label="$t('Edit')"
              icon="ti-pencil"
              class="p-button-text p-mt-2"
              @click="openAddressModal"/>
    </div>

    <div v-else class="p-d-flex p-ai-center p-jc-between p-m-2">
<!--      <span class="p-text-secondary">{{ $t('Address') }}</span>-->
      <Button style="width: auto"
              :label="$t('Add')"
              icon="pi pi-plus"
              class="p-button-text"
              @click="openAddressModal"/>
    </div>

    <small v-if="invalid" class="p-invalid p-ml-2">
      {{ $t('Required field') }}
    </small>
  </fieldset>

  <AccountAddressModal
      :visible="addressModalVisible"
      :item="addressData"
      required
      @close="closeAddressModal"
      @update-item="updateAddress"/>
</template>

<script>
import AccountAddressModal from "@/pages/account/components/AccountAddressModal.vue";

export default {
  name: 'AccountAddressFieldset',
  components: { AccountAddressModal },
  emits: ['update:modelValue'],
  props: {
    modelValue: {
      type: Object,
      default: () => ({}),
    },
    invalid: {
      type: Boolean,
      default: false,
    },
    modalLayer: {
      type: Number,
      default: 1,
    },
    label: { type: String, default: 'Address' },
  },
  data() {
    return {
      addressModalVisible: false,
    }
  },
  computed: {
    addressData() {
      return {
        address: this.modelValue?.address1 ?? null,
        address2: this.modelValue?.address2 ?? null,
        city: this.modelValue?.city ?? null,
        state: this.modelValue?.region ?? null,
        postcode: this.modelValue?.postcode ?? null,
        country_id: this.modelValue?.country_id ?? null,
        country: this.modelValue?.country ?? null,
      }
    },
    addressIsNotEmpty() {
      return !!(
          this.modelValue?.address1 ||
          this.modelValue?.address2 ||
          this.modelValue?.city ||
          this.modelValue?.region ||
          this.modelValue?.postcode ||
          this.modelValue?.country_id
      )
    },
    formattedAddress() {
      return [
        this.modelValue?.address1,
        this.modelValue?.address2,
        this.modelValue?.city,
        this.modelValue?.region,
        this.modelValue?.postcode,
        this.modelValue?.country?.name_en
        ?? this.modelValue?.country_name
        ?? this.modelValue?.country?.name_native,
      ].filter(Boolean).join(', ')
    },
  },
  watch: {
    '$store.state.secondLayerIsOpened'(isOpened) {
      if (this.modalLayer === 1 && !isOpened && this.addressModalVisible) {
        this.addressModalVisible = false
      }
    },
    '$store.state.thirdLayerIsOpened'(isOpened) {
      if (this.modalLayer === 2 && !isOpened && this.addressModalVisible) {
        this.addressModalVisible = false
      }
    },
  },
  methods: {
    openAddressModal() {
      this.addressModalVisible = true
      this.toggleModalLayer(true)
    },
    closeAddressModal() {
      this.addressModalVisible = false
      this.toggleModalLayer(false)
    },
    toggleModalLayer(value) {
      if (this.modalLayer === 2) {
        this.$store.commit('toggleThirdLayer', value)
      } else {
        this.$store.commit('toggleSecondLayer', value)
      }
    },
    updateAddress(address) {
      this.$emit('update:modelValue', {
        ...this.modelValue,
        address1: address.address ?? null,
        address2: address.address2 ?? null,
        city: address.city ?? null,
        region: address.state ?? null,
        postcode: address.postcode ?? null,
        country_id: address.country_id ?? null,
        country: address.country ?? null,
        country_name: address.country_name ?? null,
      })
    },
  },
}
</script>

<style scoped>
.location-address-fieldset--invalid {
  border-color: var(--red-500);
}
</style>
